module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="product_search_header">\n  <div class="back_button_container">\n    <i class="product_search_back_button fa-light fa-arrow-left" role="button" tabindex="0"></i>\n  </div>\n  <h3 class="product_search_title">' +
((__t = ( I18n.t('uploader.product_tagging_search.title') )) == null ? '' : __t) +
'</h3>\n  <div class="product_search_cancel_area">\n    <button class="product_search_cancel_button" type="button">' +
((__t = ( I18n.t('uploader.product_tagging_search.cancel') )) == null ? '' : __t) +
'</button>\n  </div>\n</div>\n\n<div class="product_search_container"></div>\n\n';

}
return __p
}